import React from 'react';
import { emptyTranslation } from '@colonist/i18n';
import { Button, Dialog, T } from '@colonist/ui';
import IconColonistRush from '@static/images/game_mode_icons/colonist_rush.svg';
import styles from './ColonistRushIncentiveDialog.module.scss';
const RUSH_FACTS = [
    {
        key: 'strings:popups.rushIncentive.fact1'
    },
    {
        key: 'strings:popups.rushIncentive.fact2'
    },
    {
        key: 'strings:popups.rushIncentive.fact3'
    }
];
export function ColonistRushIncentiveDialog({ open, onClose, onTryRush, onContinue, continuationText }) {
    const handleTryRush = ()=>{
        onTryRush();
        onClose();
    };
    const handleContinue = ()=>{
        onContinue();
        onClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: handleContinue
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: IconColonistRush,
            alt: emptyTranslation
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.rushIncentive.title'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.body
    }, RUSH_FACTS.map((fact)=>/*#__PURE__*/ React.createElement("p", {
            className: styles.fact,
            key: fact.key
        }, /*#__PURE__*/ React.createElement(T, {
            id: fact
        }))))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: handleContinue
    }, /*#__PURE__*/ React.createElement(T, {
        id: continuationText
    })), /*#__PURE__*/ React.createElement(Button, {
        variant: "cta",
        size: "md",
        fullWidth: true,
        onClick: handleTryRush
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.rushIncentive.tryRush'
        }
    }))));
}
